class Form {
    constructor(form) {
        this.form = form
        this.pages = [...form.querySelectorAll('[data-form-page]')]
        this.progress = form.querySelector('[data-form-progress]')
        this.indexes = form.querySelector('[data-form-indexes]')
        this.inputs = [...this.form.querySelectorAll('input, select, textarea')]
        this.currentPage = 0
        this.init()
    }

    init() {
        if (this.pages.length) {
            this.form.noValidate = true
            this.form._validators ??= []
            // only used for village
            this.initPages()
            this.initValidations()
        }
    }

    initValidations() {
        this.inputs.forEach((input) => {
            input.addEventListener('input', () => {
                const isValid = input.checkValidity()
                input.classList.toggle('error', !isValid)
            })
        })
    }

    // multi-step form
    initPages() {
        this.updateProgress()

        this.form.addEventListener('submit', (e) => {
            const action = e.submitter?.dataset.submitAction

            if (action === 'back') {
                e.preventDefault()
                this.goToPage(this.currentPage - 1)
                return
            }

            const scope = this.pages[this.currentPage]
            const isValid = this.validate(scope)

            if (!isValid) {
                e.preventDefault()
                return
            }

            if (!this.isLastPage()) {
                e.preventDefault()
                this.goToPage(this.currentPage + 1)
            }
        })
    }

    validate(scope) {
        // native validation
        const inputs = [...scope.querySelectorAll('input, select, textarea')]
        const validInputs = inputs.reduce((allValid, input) => {
            const isValid = input.reportValidity()
            input.classList.toggle('error', !isValid)
            return allValid && isValid
        }, true)

        if (!validInputs) return false

        // plugin validators
        return this.form._validators.every(v => v.validate(scope))
    }

    isLastPage() {
        return this.currentPage === this.pages.length - 1
    }

    goToPage(index) {
        if (index < 0 || index >= this.pages.length) return

        this.currentPage = index

        this.pages.forEach((page, i) => {
            page.toggleAttribute('data-form-hidden', i !== index)
        })

        this.form.scrollIntoView({ behavior: "smooth" })
        this.updateProgress()
    }

    updateProgress() {
        const current = this.currentPage + 1
        const total = this.pages.length

        if (this.progress) {
            this.progress.value = current
            this.progress.max = total
        }

        if (this.indexes) {
            this.indexes.textContent = `${this.pad(current)}/${this.pad(total)}`
        }
    }

    pad(n) {
        return String(n).padStart(2, '0')
    }
}

export default Form